
import {LoanAccount} from "@/shared/api/model";

function getTransactionStyle(trxType:any){
  switch(trxType){
    case "LDD":
      return "disbursementStyle";
    case "LRE":
      return "rescheduleStyle";
    default:
      return "transactionStyle";
  }

}

const formatStatement = (data:LoanAccount,title: String) => {
  var transactionList = [];
  transactionList.push([
    {
      "text": "Trx Date",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Trx No",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Transaction Type",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Principal",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Interest",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Total",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Additional Amount",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Principal Balance",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Interest Balance",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    },
    {
      "text": "Total Balance",
      "style": "tableHeader",
      "margin": [0, 4, 0, 4],
    }
  ]);

  var transactions = data.transactions?.map(function (transaction, i) {
    return [
      {
        "text": transaction?.transactionDateH,
        "style":getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.trxNo,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.transactionType,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.principalS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.interestS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.totalPaidS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.addAmountS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.runningPrincipalS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.runningInterestS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      },
      {
        "text": transaction?.totalBalanceS,
        "style": getTransactionStyle(transaction?.trxType?.trim()),
        "margin": [0, 4, 0, 4],
      }
    ];
  });
  
  if (!transactions || transactions.length === 0) {
    // Add a message row when there are no transactions
    transactionList.push([
      {
        "text": "No transactions found for this loan cycle",
        "style": "normalString",
        "colSpan": 10,
        "alignment": "center",
        "margin": [0, 20, 0, 20],
      },
      {}, {}, {}, {}, {}, {}, {}, {}, {}
    ]);
  } else {
    Array.prototype.push.apply(transactionList, transactions);
  }

  var dd = {
    "content": [
      {
        "text": "",
        "style": "header",
        "alignment": "center"
      },
      {
        "text": title,
        "style": "header",
        "alignment": "center"
      },
      {
          "text": data.companyName,
        "style": "subHeader",
        "alignment": "center"
      },
      {
        "style": "infoStyle",
        "table": {
          "widths": [
            125,
            245
          ]
          ,
          "body": [
            [
              {
                "text": "Account Name",
                "style": "normalString",
              },
              {
                "text": data.name,
                "style": "normalString",
              }
            ],
            [
              {
                "text": "Account Type",
                "style": "normalString",
              },
              {
                "text": data.productName,
                "style": "normalString",
              }
            ],
            [
              {
                "text": "Loan Balance",
                "style": "normalString"
              },
              {
                "text": data.loanBalanceS,
                "style": "normalString"
              }
            ],
            [
              {
                "text": "Interest Balance",
                "style": "normalString"
              },
              {
                "text": data.interestBalanceS,
                "style": "normalString"
              }
            ]
          ]
        }
      },
      {
        "style": "transactionTableStyle",
        "table": {
          "widths": [
            "8%",
            "8%",
            "9%",
            "9%",
            "9%",
            "9%",
            "9%",
            "12%",
            "12%",
            "12%",
          ]
          ,
          "body": transactionList
        }
      }
    ],
    "styles": {
      "header": {
        "fontSize": 11,
        "bold": true,
        "margin": [
          0,
          0,
          0,
          10
        ],
        "align": "center"
      },
      "subheader": {
        "fontSize": 10,
        "margin": [
          0,
          0,
          0,
          10
        ]
      },
      "infoStyle": {
        "margin": [
          340,
          40,
          0,
          15
        ],
        "layout": {
          "hLineColor": "red",
          "vLineColor": "red"
        }
      },
      "transactionTableStyle": {
        "margin": [
          0,
          40,
          0,
          15
        ],
        "layout": {
          "hLineColor": "red",
          "vLineColor": "red"
        }
      },
      "tableHeader": {
        "bold": true,
        "fontSize": 10,
        "fillColor": "#cccccc"
      },
      "tableContent": {
        "bold": true,
        "fontSize": 10,
        "color": "black"
      },
      "normalString": {
        "bold": false,
        "fontSize": 12,
        "color": "black",
        alignment: 'right'

      },
      "transactionStyle": {
        "bold": false,
        "fontSize": 8,
        "color": "black",
        alignment: 'right'

      },
      "disbursementStyle": {
        "bold": false,
        "fontSize": 8,
        "fillColor": "#80ff80",
        alignment: 'right'
      },
      "rescheduleStyle": {
        "bold": false,
        "fontSize": 8,
        "fillColor": "#ffff66",
        alignment: 'right'
      },
      "totals": {
        "bold": true,
        "fontSize": 8,
        "color": "black",
        alignment: 'right'
      }
    },
    "footer": {},
    "pageSize": "a4",
    "defaultStyle": {},
    pageOrientation: 'landscape'
  };

  return dd;
};

export default formatStatement;
